<script lang="ts" setup>
defineOptions({
  name: 'Alert',
})

const props = defineProps<{
  message: string
}>()
</script>

<template>
  <div class="toast-tip">
    {{ props.message }}
  </div>
</template>

<style lang="scss" scoped>
.toast-tip {
  color: #fff;
  border-radius: 10px;
  padding: 23px;
  background: rgba(0, 0, 0, 0.6);
  text-align: center;
  width: 254px;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999999;
}
</style>
